import { environment } from "@roman/shared/utils/environment";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Custom hook to dynamically update Apple Smart Banner meta tag
 * with current page URL as app-argument
 */
export const useAppleSmartBanner = () => {
  const location = useLocation();

  useEffect(() => {
    // Find existing meta tag
    const existingMeta = document.querySelector('meta[name="apple-itunes-app"]');

    // Check if URL contains prediction-market
    const isProd = environment.web.isProd;

    // Extract ID from URL path (e.g., /prediction-market/details/019a3916-74d5-7bbe-af88-df56a25eae56)
    const pathSegments = location.pathname.split("/");
    const id = pathSegments[pathSegments.length - 1] || "";

    // Determine app ID based on environment (check if production by API URL)
    const appId = "6748591967"; // Prediction Market app ID notion

    // Show Smart Banner for prediction market pages
    const content = `app-id=${appId}, app-argument=${isProd ? `thumba://home/details/${id}` : `thumba-stg://home/details/${id}`}`;

    if (existingMeta) {
      existingMeta.setAttribute("content", content);
    } else {
      // Create new meta tag if it doesn't exist
      const meta = document.createElement("meta");
      meta.name = "apple-itunes-app";
      meta.content = content;
      document.head.appendChild(meta);
    }
  }, [location]);
};
